<template>
    <div>
        <md-empty-state
            md-icon="broken_image"
            md-label="Content Not Found"
            md-description="We looked everywhere, but we can't seem to find what you're looking for."
        >
            <md-button class="md-primary md-raised" to="/index.html">Go Back</md-button>
        </md-empty-state>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>

<style scoped>

</style>